import React, { useEffect } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addSubCollections } from "../../Redux/Actions/collectionsActions";
import AddImage from "../../Global Functions/addImage";
import TextInput from "../../Global Functions/textInput";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";

const AddSubCollections = () => {
  const { id } = useParams();

  const [subCollectionData, setSubCollectionData] = useState({
    name: "",
    position: Math.floor(Math.random() * 1000) + 1,
    image: "",
    parent: "",
    icon: "",
    banner_image: "",
    banner_title: "",
    three_d_icon: "",
    collection_id: "",
  });

  const handleImageUpload = async (event, type) => {
    const file = event.target.files[0];
    if (!file) return;

    const imageUrl = await AddImage(file);
    if (imageUrl) {
      setSubCollectionData((prevData) => ({ ...prevData, [type]: imageUrl }));
    }
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setSubCollectionData((prevData) => ({
      ...prevData,
      parent: id,
      collection_id: id,
    }));
  }, [id]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await dispatch(addSubCollections(subCollectionData));
      if (response.statusCode === 200) {
        navigate(`/collections/view/${id}`);
      }
      setSubCollectionData({
        name: "",
        position: Math.floor(Math.random() * 1000) + 1,
        image: "",
        parent: id,
        icon: "",
      });
    } catch (error) {}
  };
  return (
    <MainLayout>
      <div
        style={{
          background: "white",
          borderRadius: "25px",
          gridColumn: "2/7",
          padding: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h1>Add Sub Collection</h1>
          <Link to={`/collections/view/${id}`}>
            <button className="button-class">View Sub-Collection List</button>
          </Link>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="flex-container gap-10">
            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="add-image">
                Upload Sub-Collection's Image
              </span>
              <input
                onChange={(event) => handleImageUpload(event, "image")}
                style={{
                  display: "none",
                }}
                type="file"
                name="image"
                id="image"
                accept="image/*"
              />
              <label className="label-class-image" htmlFor="image">
                Click to Upload Image
              </label>
              <ImageShowerModalGlobal
                file={subCollectionData.image}
                keyField="image"
                setState={setSubCollectionData}
                state={subCollectionData}
              ></ImageShowerModalGlobal>
            </div>
            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="add-image">
                Upload Sub-Collection's Icon
              </span>
              <input
                onChange={(event) => handleImageUpload(event, "icon")}
                style={{
                  display: "none",
                }}
                type="file"
                name="icon"
                id="icon"
                accept="image/*"
              />
              <label className="label-class-image" htmlFor="icon">
                Click to Upload Icon
              </label>
              <ImageShowerModalGlobal
                file={subCollectionData.icon}
                keyField="icon"
                setState={setSubCollectionData}
                state={subCollectionData}
              ></ImageShowerModalGlobal>
            </div>
          </div>

          <div className="flex-container gap-10">
            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="three_d_icon">
                Upload Sub-Collection's 3D Icon
              </span>
              <input
                onChange={(event) => handleImageUpload(event, "three_d_icon")}
                style={{
                  display: "none",
                }}
                type="file"
                name="three_d_icon"
                id="three_d_icon"
                accept="image/*"
              />
              <label className="label-class-image" htmlFor="three_d_icon">
                Click to Upload Image
              </label>
              <ImageShowerModalGlobal
                file={subCollectionData.three_d_icon}
                keyField="three_d_icon"
                setState={setSubCollectionData}
                state={subCollectionData}
              ></ImageShowerModalGlobal>
            </div>

            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="add-image">
                Upload Banner Image
              </span>
              <input
                onChange={(event) => handleImageUpload(event, "banner_image")}
                style={{
                  display: "none",
                }}
                type="file"
                name="banner_image"
                id="banner_image"
                accept="image/*"
              />
              <label className="label-class-image" htmlFor="banner_image">
                Click to Upload Image
              </label>
              <ImageShowerModalGlobal
                file={subCollectionData.banner_image}
                keyField="banner_image"
                setState={setSubCollectionData}
                state={subCollectionData}
              ></ImageShowerModalGlobal>
            </div>
          </div>
          <div className="flex-container gap-10">
            <div style={{ width: "50%" }}>
              <TextInput
                value={subCollectionData.name}
                onChange={(event) =>
                  setSubCollectionData((prevData) => ({
                    ...prevData,
                    name: event.target.value, // Directly updating the name field
                  }))
                }
                label="Sub Collection Name"
                placeholder="Enter Name"
              ></TextInput>
            </div>
            <div style={{ width: "50%" }}>
              <TextInput
                value={subCollectionData.banner_title}
                onChange={(event) =>
                  setSubCollectionData((prevData) => ({
                    ...prevData,
                    banner_title: event.target.value, // Directly updating the name field
                  }))
                }
                label="Banner Title"
                placeholder="Enter Name"
              ></TextInput>
            </div>
          </div>

          <div className="flex-end" style={{ margin: "20px 0px" }}>
            <Link to={`/collections/view/${id}`}>
              <button className="button-class-white">Cancel</button>
            </Link>
            <button className="button-class" type="submit">
              Save
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default AddSubCollections;
